define('v3/Common/Components/AbilityGrowthArrows/AbilityGrowthArrows.Component',[
	'knockout',
	'v3/Common/Services/abilityGrowthService',
	'text!v3/Common/Components/AbilityGrowthArrows/AbilityGrowthArrows.Component.html',
	'v3/Common/Bindings/SvgIcon.Binding'
],
function (ko, abilityGrowthService, htmlString) {
	function validateParams (params, usePupilAverageGrowth) {
		if (usePupilAverageGrowth) {
			if (!params.score) {
				throw new Error('params.score is expected.');
			}
		} else {
			if (!params.actualGrowth) {
				throw new Error('params.actualGrowth is expected.');
			}
			if (!params.expectedGrowth) {
				throw new Error('params.expectedGrowth is expected.');
			}
		}
	}

	var scores = abilityGrowthService.scores;

	function getAverageGrowthClass (score) {
		if (score) {
			var growthClasses = [
				scores.none,
				scores.farWorse,
				scores.worse,
				scores.equal,
				scores.better,
				scores.farBetter
			];
			return growthClasses[score];
		}
		return scores.none;
	}

	function getDescriptionForGrowthClass (growthClass, usePupilAverageGrowth) {
		switch (growthClass) {
		case scores.farBetter:
			return usePupilAverageGrowth ? Strings.PercentileLabelFarAbove : Strings.FarMoreThanExpected;
		case scores.better:
			return usePupilAverageGrowth ? Strings.PercentileLabelAbove : Strings.MoreThanExpected;
		case scores.equal:
			return usePupilAverageGrowth ? Strings.PercentileLabelAverage : Strings.AsExpected;
		case scores.worse:
			return usePupilAverageGrowth ? Strings.PercentileLabelBelow : Strings.LessThanExpected;
		case scores.farWorse:
			return usePupilAverageGrowth ? Strings.PercentileLabelFarBelow : Strings.FarLessThanExpected;
		default:
			return usePupilAverageGrowth ? Strings.NoGrowthFound : '';
		}
	}

	function AbilityGrowthArrowsViewModel (params) {
		var self = this;

		self.growthClass = ko.observable(null);
		self.growthClassCss = ko.observable(null);
		self.growthClassDescription = ko.observable(null);
		self.usePupilAverageGrowth = Settings.usePupilAverageGrowth || false;
		validateParams(params, self.usePupilAverageGrowth);

		ko.computed(function () {
			var growthClass = scores.none;
			if (self.usePupilAverageGrowth) {
				var score = ko.unwrap(params.score);
				growthClass = getAverageGrowthClass(score);
			} else {
				var actualGrowth = ko.unwrap(params.actualGrowth);
				var expectedGrowth = ko.unwrap(params.expectedGrowth);

				if ((!actualGrowth && actualGrowth !== 0) || (!expectedGrowth && expectedGrowth !== 0)) return;

				growthClass = abilityGrowthService.getGrowthClass(actualGrowth, expectedGrowth);
			}
			self.growthClass(growthClass.name);
			self.growthClassCss(growthClass.css);
			self.growthClassDescription(getDescriptionForGrowthClass(growthClass, self.usePupilAverageGrowth));
		});
	}

	return { viewModel: AbilityGrowthArrowsViewModel, template: htmlString };
});
